import { CenteredSpinner } from '~/commonComponents/CenteredSpinner';
import { Center } from '~/commonComponents';
import { PageContainer } from '~/commonComponents/PageContainer';
import { Suspense } from 'react';
import { PDFPreviewConsent } from '~/commonComponents/PDFPreviewConsent';

export const SignUpTermsAndConditions = ({
  handleAccept,
  pdfUrl,
  isLoading,
}: {
  handleAccept: () => void;
  pdfUrl: string;
  isLoading: boolean
}) => {
  return (
    <Suspense
      fallback={
        <PageContainer>
          <div
            className="floating_container"
            style={{
              flexDirection: 'column',
              justifyContent: 'flex-start',
              marginInline: '20px',
            }}
          >
            <Center marginTop={40}>
              <CenteredSpinner />
            </Center>
          </div>
        </PageContainer>
      }
    >
      <PDFPreviewConsent
        pdfUrl={pdfUrl}
        isAccepting={false}
        isLoading={isLoading}
        onConsent={handleAccept}
        minHeight={'100vh'}
      />
    </Suspense>
  );
};
